export default __webpack_public_path__ + "static/media/position-csv-sample.552675bf.csv";